import lowercase from '@grouper/modules/core/filters/lowercase'
import nameAbbreviation from '@grouper/modules/core/filters/nameAbbreviation'
import uppercase from '@grouper/modules/core/filters/uppercase'

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      filters: {
        lowercase,
        uppercase,
        nameAbbreviation,
      },
    },
  }
})
